export const asset = {
  danger_icon: require('./danger.svg')
}
